import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

export type VetListItemDto = { placeId: string; name: string; lat: number; lng: number; };
export type ReviewDto = { authorName?: string; text?: string; rating?: number; time?: string; profilePhotoUrl?: string; };
export type VetDetailsDto = {
    vetId: string; name: string; phoneNumber?: string; rating?: number; ratingsTotal?: number;
    website?: string; formattedAddress?: string; openingHours?: string[]; isOpen?: boolean;
    lat: number; lng: number; reviews?: ReviewDto[];
};

@Injectable({ providedIn: 'root' })
export class PlacesApiService {
    private base = environment.apiUrl; // e.g. https://api.mimboapp.com

    constructor(private http: HttpClient) { }

    async nearbyVets(lat: number, lng: number, openNow?: boolean): Promise<VetListItemDto[]> {
        const url = environment.apiUrl + '/api/maps/nearby';
        const params = new HttpParams()
            .set('lat', lat)
            .set('lng', lng)
            .set('openNow', String(!!openNow));
        return await firstValueFrom(this.http.get<VetListItemDto[]>(url, { params }));
    }

    async vetDetails(placeId: string): Promise<VetDetailsDto> {
        const url = environment.apiUrl + '/api/maps/details/' + placeId;
        return await firstValueFrom(this.http.get<VetDetailsDto>(url));
    }
}
